import zipCodeHash from './zip-code-hash.js'

class MiniCart extends HTMLElement {
  constructor() {
    super();

    this.selectElements();
    this.getCartInfo();
    this.attachListeners();
  }

  get info() {
    return {
      item_count: this.item_count,
      items: this.items,
      total_price: this.total_price
    };
  }

  selectElements() {
    this.root = this.firstElementChild;
    this.contentWrapper = this.root.firstElementChild;
    this.checkoutButton = document.querySelector('button[data-testid="cartSubmit"');
    this.removeItemButtons = this.querySelectorAll('.js-remove-cart-item');
    this.editItemButtons = this.querySelectorAll('.js-edit-cart-item');
    this.cartProductEditCancelButtons = this.querySelectorAll('button#cart-product-edit-cancel');
    this.cartSampleEditCancelButtons = this.querySelectorAll('button#cart-sample-edit-cancel');
    this.decreaseItemQuantityButtons = this.querySelectorAll('button#decrease-cart-item');
    this.increaseItemQuantityButtons = this.querySelectorAll('button#increase-cart-item');
    this.updateSampleButtons = this.querySelectorAll('button#cart-sample-edit-save');
    this.editItemQuantityInputs = this.querySelectorAll('input#cart-item-quantity-input');
    this.enterZipCode = this.querySelector('div[data-testid="enter-zipcode"');
    this.zipCodeInput = this.querySelector('input[name="zipcode"');
    this.estimateShipping = this.querySelector('div[data-testid="estimate"');
    this.estimateShippingValue = this.querySelector('div#estimated-shipping');
    this.estimatedTotal = this.querySelector('div#estimated-total');
    this.closeCart = document.querySelector('button[data-testid="closeMicrocart"]');
    this.openCart = document.querySelector('button[data-testid="openMicrocart"]');
    this.cartCount = document.querySelector('span#mini-cart-count');
    this.closeEmptyCart = this.querySelector('button#close-empty-cart');
    this.clearCartEl = this.querySelector('button#js-clear-cart');
    this.overlay = document.querySelector('div.overlay');
  }

  open() {
    this.root.classList.add('fade-enter-active');
    this.root.classList.remove('fade-leave-active');
    this.overlay.style.display = 'block';
  }

  close() {
    this.root.classList.replace('fade-enter-active', 'fade-leave-active');
    this.overlay.style.display = 'none';
  }

  clearCart() {
    fetch('/cart/clear.js', {
       method: 'POST',
       body: JSON.stringify({
        sections: 'cle-sidebar-cart',
      }),
      headers: {
        'Content-Type': 'application/json'
      }
       })
      .then((resp) => resp.json())
      .then((respJson) => {
        this.refreshCartUI(respJson.sections['cle-sidebar-cart'])
        this.updateCount(0)
      })
      .catch((error) => {
        console.error('Error clearing cart:', error);
      });
  }

  update(updates) {
    return fetch('/cart/update.js', {
      method: 'POST',
      body: JSON.stringify({
        updates,
        sections: 'cle-sidebar-cart',
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    }).then(data => {
      this.updateCount(data.items.length);
      this.refreshCartUI(data.sections['cle-sidebar-cart']);
      if (typeof cart !== 'undefined')
        cart.items = data.items;
      if (window.refreshPDPCalculator)
        window.refreshPDPCalculator();
    }).catch(err => {
      console.log('error: ', err);
    });
  }

  estimateShippingCost({ zip, province }) {
    const params = new URLSearchParams();
    params.set('shipping_address[zip]', zip)
    params.set('shipping_address[country]', 'United States')
    params.set('shipping_address[province]', province)
    fetch(`/cart/shipping_rates.json?${params.toString()}`, {
      method: 'GET',
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        if (data.shipping_rates.length) {
          this.estimateShippingValue.textContent = '$' + data.shipping_rates[0].price;
          this.estimatedTotal.textContent = '$' + (this.total_price / 100 + parseFloat(data.shipping_rates[0].price)).toFixed(2);
        } else {
          this.estimateShippingValue.textContent = "$ - -";
        }
      })
      .catch(err => {
        console.log('error: ', err);
        this.estimateShippingValue.textContent = "$ - -";
      });
  }

  async updateCount(value) {
    if (value === undefined || value === null) {
      const cart = await this.getCartInfo();
      value = cart.items.length;
    }
    this.cartCount.innerHTML = value;
  }

  getCartInfo() {
    const promise =
      fetch('/cart/update.js', {
        method: 'GET',
      })
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then(data => {
          this.item_count = data.item_count;
          this.items = data.items;
          this.total_price = data.total_price; // Cents
          if (typeof cart !== 'undefined')
            cart.items = data.items;
          if (window.refreshPDPCalculator)
            window.refreshPDPCalculator();
          return data;
        })
        .catch(err => {
          console.log('error: ', err);
          throw err;
        });
    return promise;
  }

  refreshCartUI(data) {
    const content = new DOMParser()
      .parseFromString(data, 'text/html')
      .querySelector('#content-wrapper').innerHTML;
    this.contentWrapper.innerHTML = content;

    // Reattach listeners
    this.selectElements();
    this.attachListeners();
    document.dispatchEvent(new Event('cart:refreshComplete'));
  }

  refresh() {
    return fetch('/?section_id=cle-sidebar-cart', {
      method: 'GET',
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.text();
      })
      .then(data => {
        const content = new DOMParser()
          .parseFromString(data, 'text/html')
          .querySelector('#content-wrapper').innerHTML;
        this.contentWrapper.innerHTML = content;

        // Reattach listeners
        this.selectElements();
        this.attachListeners();
      })
      .catch(err => {
        console.log('error: ', err);
      });
  }

  attachListeners() {
    this.closeCart.addEventListener('click', (e) => {
      this.close();
    });
    this.openCart.addEventListener('click', (e) => {
      this.open();
    });
    this.closeEmptyCart?.addEventListener('click', (e) => {
      this.close();
    });
    this.clearCartEl?.addEventListener('click', (e) => {
      this.clearCart();
    });

    this.removeItemButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        if (e.target.nodeName !== 'BUTTON') return;
        const variant_id = e.target.dataset.variantId;
        const item_index = e.target.dataset.lineItemIndex;
        const sealant_id = e.target.dataset.topCoatId;
        const sealant = document.getElementById('cart-total-sealant');
        var sealant_qty = parseInt(e.target.dataset.topCoatQty),
          total_sealant_qty = sealant ? parseInt(sealant.dataset.topCoatTotal) : 0,
          new_sealant_qty = total_sealant_qty - sealant_qty;
        const action = () => {
          const variantRemovedEvent = new CustomEvent('cart:variantRemoved', {
            detail: { variantId: variant_id }
          });
          if (sealant_id != null) {
            this.update({ [item_index]: 0, [sealant_id]: new_sealant_qty })
            .then(() => {
              document.dispatchEvent(variantRemovedEvent);
              document.dispatchEvent(variantRemovedEvent);
            })
          } else {
            this.update({ [item_index]: 0 })
            .then(() => {
              document.dispatchEvent(variantRemovedEvent);
              document.dispatchEvent(variantRemovedEvent);
            })
          }
          // window.clearCacheCartItemData(variant_id);
          window.current_product = undefined;
        };
        window.notificationsManager.open({
          type: "NOTIFICATION_CANCELABLE",
          tone: "INFO",
          message: 'Are you sure you would like to remove this item from the shopping cart?',
          action
        });
      });
    });

    const cartCalculatorForm = document.getElementById('cart-calculator-form');
    this.editItemButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        const item_product_type = e.target.dataset.lineItemProductType;
        const item_index = e.target.dataset.lineItemIndex;

        // Toggle the visibility
        if (item_product_type && item_product_type.startsWith("Sample")) {
          const actions = button.closest('.js-cart-item-actions')
          actions.classList.add('hidden');
          
          const editQuantityGroup = document.querySelector(`div[id="edit-sample-quantity-group"][data-line-item-index="${item_index}"]`);
          editQuantityGroup.classList.remove('hidden');
          
          const quantityInput = editQuantityGroup.querySelector(`input[name="quantity"]`);
          quantityInput.value = quantityInput.dataset.lineItemQty;
        } else {
          // load product data into calculator
          const cartItemEditEvent = new CustomEvent('cart:editStarted', {
            detail: { 
              productData: e.target.dataset.productData,
              coverage: e.target.dataset.coverage,
              overage: e.target.dataset.overage,
              qty: e.target.dataset.qty
           }
          });
          // const productData = e.target.dataset.productData;
          // cartCalculatorForm.dataset.productData = productData;


          // copy product details into cart calculator
          const productDetail = button.closest('.js-cart-item').cloneNode(true);
          const actions = productDetail.querySelector('.js-cart-item-actions');
          actions.remove();
          const productDetailElement = document.getElementById('cart-calculator-product-content');
          productDetailElement.innerHTML = productDetail.innerHTML;
          
          document.dispatchEvent(cartItemEditEvent);
          // make calculator visible
          cartCalculatorForm.classList.remove('hidden');

          const editItemSection = document.getElementById('cart-calculator-edit-section');
          editItemSection.classList.remove('hidden');
          
          const cartItemsViewSectionBody = document.getElementById('cart-items-view-section-body');
          cartItemsViewSectionBody.classList.add('hidden');
          
          const cartItemsViewSectionFooter = document.getElementById('cart-items-view-section-footer');
          cartItemsViewSectionFooter.classList.add('hidden');
          // Initialize product calculation
          // window.current_lineitem_index = item_index;
          // window.onLoadCartProductItemForEditing();
        }
      });
    });

    const updateSampleQuantity = (lineItemIndex, qty) => {
      if (qty > 4) {
        return window.notificationsManager.open({
          type: "NOTIFICATION_INFO",
          tone: "ERROR",
          message: 'The requested quantity exceeds the maximum allowed in the shopping cart.'
        });
      }
      this.update({ [lineItemIndex]: Math.max(qty, 0) });
    };

    this.decreaseItemQuantityButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        const item_index = e.currentTarget.dataset.lineItemIndex;
        const editQuantityGroup = document.querySelector(`div[id="edit-sample-quantity-group"][data-line-item-index="${item_index}"]`);
        const quantityInput = editQuantityGroup.querySelector(`input[name="quantity"]`);
        let newValue;
        if (isNaN(Number(quantityInput.value)))
          newValue = 0;
        else
          newValue = Math.max(Number(quantityInput.value) - 1, 0);
        quantityInput.value = newValue;
      });
    });

    this.increaseItemQuantityButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        const item_index = e.currentTarget.dataset.lineItemIndex;
        const editQuantityGroup = document.querySelector(`div[id="edit-sample-quantity-group"][data-line-item-index="${item_index}"]`);
        const quantityInput = editQuantityGroup.querySelector(`input[name="quantity"]`);
        let newValue;
        if (isNaN(Number(quantityInput.value)))
          newValue = 0;
        else
          newValue = Math.min(Number(quantityInput.value) + 1, 4);
        quantityInput.value = newValue;
      });
    });

    this.editItemQuantityInputs.forEach((input) => {
      input.addEventListener('keypress', (e) => {
        if (e.key !== 'Enter')
          return;
        const item_index = e.currentTarget.dataset.lineItemIndex;
        var new_item_qty = parseInt(e.currentTarget.value) || 0;
        updateSampleQuantity(item_index, new_item_qty);
      });
      input.addEventListener('input', () => {
        setLengthLimitForInput(input);
      });
    });

    this.updateSampleButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        const item_index = e.currentTarget.dataset.lineItemIndex;
        const editQuantityGroup = document.querySelector(`div[id="edit-sample-quantity-group"][data-line-item-index="${item_index}"]`);
        const quantityInput = editQuantityGroup.querySelector(`input[name="quantity"]`);
        let new_item_qty = Number(quantityInput.value) || 0;
        updateSampleQuantity(item_index, new_item_qty);
      });
    })

    this.cartProductEditCancelButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        const item_index = e.target.dataset.lineItemIndex;
        const item_product_type = e.target.dataset.lineItemProductType;
        const editItemSection = document.querySelector(`div[id="cart-item-editing-section"][data-line-item-index="${item_index}"]`);
        const cartItemsViewSectionBody = document.getElementById('cart-items-view-section-body');
        const cartItemsViewSectionFooter = document.getElementById('cart-items-view-section-footer');
        // Toggle the visibility
        if (item_product_type !== 'Sample') {
          editItemSection.classList.add('hidden');
          cartItemsViewSectionBody.classList.remove('hidden');
          cartItemsViewSectionFooter.classList.remove('hidden');
        }
        window.current_product = undefined;
      });
    });

    this.cartSampleEditCancelButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        const item_index = e.target.dataset.lineItemIndex;
        const cartItemNode = e.target.closest('.js-cart-item')
        const actions = cartItemNode.querySelector('.js-cart-item-actions');
        // const removeItemButton = document.querySelector(`button[id="remove-cart-item"][data-line-item-index="${item_index}"]`);
        // const editItemButton = document.querySelector(`button[id="edit-cart-item"][data-line-item-index="${item_index}"]`);
        const editQuantityGroup = document.querySelector(`div[id="edit-sample-quantity-group"][data-line-item-index="${item_index}"]`);
        // Toggle the visibility
        // removeItemButton.classList.remove('hidden');
        // editItemButton.classList.remove('hidden');
        actions.classList.remove('hidden');
        editQuantityGroup.classList.add('hidden');
        window.current_product = undefined;
      });
    });

    this.estimateShipping?.addEventListener('click', (e) => {
      const isVisible = this.enterZipCode.style.display === 'block';
      if (isVisible) {
        this.enterZipCode.style.display = 'none';
        this.estimateShipping.parentNode.classList.replace('justify-between', 'justify-end');
      } else {
        this.enterZipCode.style.display = 'block';
        this.estimateShipping.parentNode.classList.replace('justify-end', 'justify-between');
      }
    });

    this.zipCodeInput?.addEventListener('input', e => {
      const zip = e.target.value;
      if (zip) this.zipCodeInput.classList.remove('empty');
      else this.zipCodeInput.classList.add('empty');

      if (zip.length < 5) return;

      this.estimateShippingValue.textContent = 'loading ...';
      this.estimateShippingCost({ zip, province: zipCodeHash[zip.substring(0, 3)] });
    });
    if (this.checkoutButton) {
      this.checkoutButton.addEventListener('click', () => {
        window.location.href = '/checkout';
      });
    }
  }
}

customElements.define('cle-sidebar-cart', MiniCart);
